export const KB_TOPIC_SUGGESTIONS = [
  "Продажи",
  "Товары",
  "Инструкции",
  "Должностные обязанности",
  "Онбординг",
  "Сервис и поддержка",
  "Документы",
  "Безопасность",
];

export function createTopicWithTitle(title, parentId = null) {
  return {
    id: `topic-${Date.now()}-${Math.random().toString(36).slice(2, 7)}`,
    parentId,
    title: String(title ?? "").trim(),
  };
}

export function hasTopicWithTitle(topics, title) {
  const normalized = String(title ?? "").trim().toLowerCase();
  if (!normalized) return false;
  return (topics ?? []).some(
    (topic) =>
      (topic.parentId ?? null) === null &&
      String(topic.title ?? "").trim().toLowerCase() === normalized,
  );
}
